@defer (when collectionViewModel) {
@if (collectionViewModel?.isVisible) {
  @if (collectionViewModel && showToolbar) {
    <div class="toolbar-section">
      <div class="toolbar-control-content">
        <div class="horizontal-container">
          @if (isSecurityAccessReadOnly()) {
            <div class="locked-field">
              <svg-icon key="locked"
                [popper]="securityTooltipDescription"
                [popperDisabled]="!securityTooltipDescription || securityTooltipDescription?.length == 0"
                [popperTrigger]="ngxPopperjsTriggers.hover"
                [popperDelay]="1000"
                [popperApplyClass]="securityTooltipClass"
                [popperPlacement]="ngxPopperjsPlacements.TOP"
                [popperPreventOverflow]="false"
                [popperHideOnScroll]="true"
                popperAppendTo="body">
              </svg-icon>
            </div>
          }
          @if (title?.length > 0 && showTitle) {
            <div class="caption-control" role="heading" aria-level="3">{{
            title }}</div>
          }
          <div class="root-container">
            <div class="inline-command-bar">
              <div class="action-list-control-container">
                <div class="horizontal-flex-container">
                  @if (title?.length > 0 && showTitle) {
                    <div class="navigation-bar-row-separator">
                    </div>
                  }
                  @for (commandName of defaultCommandsName.concat(customCommandsName); track commandName) {
                    @if (this.collectionViewModel.getCommand(commandName).isVisible$ | async) {
                      <div class="horizontal-flex-container-item-layout"
                        [class.hidden-on-mobile]="this.collectionViewModel.getCommand(commandName).hiddenOnMobile$ | async"
                        [class.hidden-on-desktop]="this.collectionViewModel.getCommand(commandName).hiddenOnDesktop$ | async"
                        >
                        <div class="command-bar-button-container">
                          <nts-ribbon-button
                            [title]="this.collectionViewModel.getCommand(commandName).tooltip$ | async"
                            [tabIndex]="0"
                            [label]="this.collectionViewModel.getCommand(commandName).displayName$ | async"
                            [icon]="this.collectionViewModel.getCommand(commandName).iconClass$ | async"
                            [isLoading]="this.collectionViewModel.getCommand(commandName).loading$ | async"
                            [isDisabled]="areAllCommandsDisabled || !(this.collectionViewModel.getCommand(commandName).canExecute$ | async) || collectionViewModel?.securityAccess != null"
                            (onClicked)="this.collectionViewModel.getCommand(commandName).execute(this.collectionViewModel.getCommand(commandName), $event)">
                          </nts-ribbon-button>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
          @if (!isSecurityAccessDeny(); as commandName) {
            @for (commandName of defaultViewCommandsName.concat(customViewCommandsName); track commandName) {
              @if (this.collectionViewModel.getCommand(commandName).isVisible$ | async) {
                <div
                  class="command-bar-button-container"
                  [class.hidden-on-mobile]="this.collectionViewModel.getCommand(commandName).hiddenOnMobile$ | async"
                  [class.hidden-on-desktop]="this.collectionViewModel.getCommand(commandName).hiddenOnDesktop$ | async">
                  @if (this.collectionViewModel.getCommand(commandName).isTextbox) {
                    <nts-ribbon-text-box
                      [title]="this.collectionViewModel.getCommand(commandName).tooltip$ | async"
                      [isDisabled]="!(this.collectionViewModel.getCommand(commandName).canExecute$ | async)"
                      [placeholder]="this.collectionViewModel.getCommand(commandName).displayName$ | async"
                      (onInputChange)="this.collectionViewModel.getCommand(commandName).execute(this.collectionViewModel.getCommand(commandName), $event)">
                    </nts-ribbon-text-box>
                  }
                  @if (!this.collectionViewModel.getCommand(commandName).isTextbox) {
                    <nts-ribbon-button
                      [title]="this.collectionViewModel.getCommand(commandName).tooltip$ | async" [tabIndex]="0"
                      [icon]="this.collectionViewModel.getCommand(commandName).iconClass$ | async"
                      [isLoading]="this.collectionViewModel.getCommand(commandName).loading$ | async"
                      [tooltipAppendTo]="tooltipAppendTo"
                      [isDisabled]="!(this.collectionViewModel.getCommand(commandName).canExecute$ | async)"
                      (onClicked)="this.collectionViewModel.getCommand(commandName).execute(this.collectionViewModel.getCommand(commandName), $event)">
                    </nts-ribbon-button>
                  }
                </div>
              }
            }
          }
        </div>
      </div>
    </div>
  }
  <div class="grid-section" [class.no-rows]="collectionViewModel?.length === 0 || !collectionViewModel">
    @if (isSecurityAccessDeny()) {
      <div class="locked-grid">
        <svg-icon key="locked"
          [popper]="securityTooltipDescription"
          [popperDisabled]="!securityTooltipDescription || securityTooltipDescription?.length == 0"
          [popperTrigger]="ngxPopperjsTriggers.hover"
          [popperDelay]="1000"
          [popperApplyClass]="securityTooltipClass"
          [popperPlacement]="ngxPopperjsPlacements.TOP"
          [popperPreventOverflow]="false"
          [popperHideOnScroll]="true"
          popperAppendTo="body">
        </svg-icon>
      </div>
    } @else {
      <ag-grid-angular
        #popperError="popper"
        [class.has-error]="($safeNavigationMigration(collectionViewModel?.errors$) | async)?.length > 0"
        [popper]="tooltipErrTemplate"
        [popperDisabled]="($safeNavigationMigration(collectionViewModel?.errors$) | async)?.length === 0"
        [popperTrigger]="ngxPopperjsTriggers.hover"
        popperApplyClass="error"
        [popperPlacement]="ngxPopperjsPlacements.TOP"
        [popperPreventOverflow]="false"
        popperAppendTo="body"
        (rowClicked)="rowClicked($event)"
        (keydown.space)="preventScrollWithoutFocus($event)"
        (cellKeyDown)="onCellKeyDown($event)"
        (keydown.shift.enter)="onEnterGrid()"
        (columnResized)="onColumnResized($event)"
        [rowBuffer]="pagination ? 0 : this.minRowNumberHeight * 5 || 34"
        [columnDefs]="columnDefinitions"
        [suppressDragLeaveHidesColumns]="true"
        [components]="components"
        [stopEditingWhenCellsLoseFocus]="false"
        [loading]="isLoading$ | async"
        [overlayLoadingTemplate]="loadingText$ | async"
        [enableCellTextSelection]="true"
        [headerHeight]="34"
        [rowHeight]="34"
        [gridOptions]="gridOptions"
        [suppressNoRowsOverlay]="true"
        [rowData]="this.pagination ? undefined : collectionViewModel"
        tabindex="0"
        style="width: 100%"
        class="ag-theme-nts">
      </ag-grid-angular>
      @if (overlayText) {
        <div class="overlay-text-container">
          <div class="overlay-text-description">
            {{overlayText}}
          </div>
        </div>
      }
    }
    <!-- <nts-grid-columns-sidebar [class.hidden]="!showColumnSettings" [style.max-width.px]="gridSection.clientWidth"
    [style.height.px]="gridSection.clientHeight" [collectionViewModel]="collectionViewModel" [columns]="columns"
    [actionInProgress]="false" [isCollapsed]="!showColumnSettings">
  </nts-grid-columns-sidebar> -->
</div>
}

}

@if (loadingError) {
  <div class="error-container">
    <div class="error-message">
      <p>{{ loadingError?.description || 'Impossibile caricare il componente.' }}</p>
    </div>
  </div>
}

<popper-content #tooltipErrTemplate>
  @for (item of $safeNavigationMigration(collectionViewModel?.errors$) | async; track item) {
    {{ item }}
  }
</popper-content>